<div class="logo-container" [ngStyle]="{ width: size, height: size }">
  <img class="logoImg" [src]="'assets/stations/' + stationCpo?.toLowerCase() + 'logo.svg'" />
</div>
